import * as classNames from 'classnames';
import { DataService } from '../../../services/data_service';
import { disableKosten } from '../../../helpers/showKosten';
import { fn2, fn2nZ } from '../../../core/formatter/formatNumber';
import { formStyle, WFormData, WFormFieldArchiv } from '../../../core/forms/WFormFramework';
import { getEmissionsFaktorForTid } from '../../../main/functions/getEmmissionsFaktor';
import { IDs } from '../../../helpers/IDs';
import { isValid as isValidWaerme } from '../../../main/functions/validData';
import { lazyInject } from '../../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { removeErrorLevelAddOn } from '../../../core/forms/helpers/errorLevelTools';
import style from './DialogWaermeVerbrauch.less';
import { validateFieldUniversal } from '../functions/validateField';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';
import { isConfigVorsteuerNetto } from '../co2_custom/getCustomFormConfig';

export interface DialogWaermeVerbrauchProps {
    data: any;
    standortSelected: any;
    jahr: any;
    values: any;
    onChange: (entityName: string, formValues: any) => void;
    onClose: () => void;
}

export interface DialogWaermeVerbrauchState {
    data: any;
    showSpinner: boolean;
}

export class DialogWaermeVerbrauch extends React.Component<DialogWaermeVerbrauchProps, DialogWaermeVerbrauchState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            showSpinner: false
        };
        this.onChange = this.onChange.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;

    private abrechnungsart: number;
    private autoCo2Emissionen: boolean;
    private disableKosten: boolean;
    private einheit: string;
    private einheit_tid: number;
    private energietraeger: string;
    private energietraeger_tid: number;
    private emissionsfaktor: number;
    private FormData: any = new WFormData();
    private harmCo2Emissionen: number;
    private sumKosten: number;
    private sumVerbrauch: number;
    private isVorsteuerNetto: boolean = isConfigVorsteuerNetto(this.props.data);

    componentDidMount(): void {
        const row: any = this.props.values || {};
        const parent_tid = row.tid || 0;
        const energietraeger_tid = typeof row.energietraeger_tid === 'number'
            ? row.energietraeger_tid
            : (typeof row.energietraeger_tid_orig === 'number' ? row.energietraeger_tid_orig : 0);
        const einheit_tid = typeof row.einheit_tid === 'number'
            ? row.einheit_tid
            : (typeof row.einheit_tid_orig === 'number' ? row.einheit_tid_orig : 0);
        const waerme = this.props.data[IDs.ENT_ENERGIEDATEN_WAERME] || [];
        const data: any = {};
        // Feld "CO₂-Emissionen" deaktivieren wenn der energieträger NICHT Fernwärme & Fernkälte ist
        this.autoCo2Emissionen = energietraeger_tid !== 7 /*Fernwärme*/ && energietraeger_tid !== 21 /*Fernkälte*/;
        waerme.filter((item: any) =>
            item.standort_tid_orig === this.props.standortSelected.tid
            && item.jahr === this.props.jahr
            && item.monat >= 1
            && (item.energietraeger_tid_orig || 0) === energietraeger_tid
            && (item.einheit_tid_orig || 0) === einheit_tid
            && item.parent_tid === parent_tid
        ).forEach((item: any) => data[item.monat] = item);
        this.abrechnungsart = row.abrechnungsart || 0;
        this.einheit = (((this.props.data[`${IDs.ENT_ENERGIEDATEN_WAERME}_bundle`] || {}).einheit_tid || [])
            .find((item: any) => item.tid === einheit_tid) || {}).name || null;
        this.einheit_tid = einheit_tid;
        this.emissionsfaktor = +getEmissionsFaktorForTid(this.props.data, this.props.jahr, energietraeger_tid);
        this.emissionsfaktor = +this.emissionsfaktor > 0 ? this.emissionsfaktor * 1000000 : this.emissionsfaktor;
        this.energietraeger = (((this.props.data[`${IDs.ENT_ENERGIEDATEN_WAERME}_bundle`] || {}).energietraeger_tid || [])
            .find((item: any) => item.tid === energietraeger_tid) || {}).name || null;
        this.energietraeger_tid = energietraeger_tid;
        this.FormData.setBundle(this.props.data[`${IDs.ENT_ENERGIEDATEN_WAERME}_bundle`] || {});
        this.disableKosten = disableKosten(this.props.data);
        this.setState({ data });
    }

    getParentAbrechnungszeitraumBis(rows: any[]): number {
        let az = 0;

        rows.forEach((row: any) => {
            if (!isValidWaerme({ ...row, abrechnungsart: this.abrechnungsart }, IDs.ENT_ENERGIEDATEN_WAERME, this.props.data)) {
                return;
            }

            if (row.abrechnungszeitraum_bis > 0 && az < row.abrechnungszeitraum_bis) {
                az = row.abrechnungszeitraum_bis;
            }
        });

        return az;
    }

    getParentAbrechnungszeitraumVon(rows: any[]): number {
        let az = 0;

        rows.forEach((row: any) => {
            if (!isValidWaerme({ ...row, abrechnungsart: this.abrechnungsart }, IDs.ENT_ENERGIEDATEN_WAERME, this.props.data)) {
                return;
            }

            if (row.abrechnungszeitraum_von > 0 && (az === 0 || az > row.abrechnungszeitraum_von)) {
                az = row.abrechnungszeitraum_von;
            }
        });

        return az;
    }

    getValue(value: any): any {
        return typeof value !== 'undefined' && value !== null && !isNaN(+value) ? +value : null;
    }

    onChange(data: any): void {
        const index: number = typeof data.index === 'number' ? data.index : null;
        const value: any = data.value || null;
        const name: string = data.name || (this.state.data[index] || null);
        const values: any = this.state.data;
        values[index] = { ...values[index], [name]: value };
        this.setState({ data: values });
    }

    render(): JSX.Element {
        if (!this.state.data) {
            return null;
        }
        return (
            <div className={classNames(formStyle.sidebysideComplex, style.wrapper)}>
                {/* {this.renderTitle()} */}
                {this.renderHeader()}
                {this.renderVerbraeuche()}
                {this.renderFooter()}
                {this.state.showSpinner && <WSpinner />}
            </div>
        );
    }

    renderButtons(): JSX.Element {
        return (
            <div
                className={style.buttons}
                style={{ width: 250, padding: 0, maxWidth: 'unset' }}
            >
                <WActionButton
                    disabled={this.state.showSpinner}
                    label='Werte speichern und übernehmen'
                    insideText='Werte speichern und übernehmen'
                    key='save'
                    action='save'
                    onAction={() => this.saveData()}
                    styleProps={{
                        width: 245, marginLeft: 3
                    }}
                />
                {/*<WActionButton
                    label='Schließen'
                    insideText='Schließen'
                    key='close'
                    action='delete'
                    onAction={this.props.onClose}
                />*/}
            </div>
        );
    }

    renderFooter(): JSX.Element {
        return (
            <div className={style.footer}>
                <div>Summen</div>
                <div>{fn2(this.sumVerbrauch)}</div>
                <div style={this.disableKosten ? { display: 'none' } : {}}>
                    {fn2nZ(this.sumKosten)}
                </div>
                <div>
                    <span style={{ float: 'left' }}>Mittel</span>
                    {fn2(this.harmCo2Emissionen)}
                </div>
                {this.renderButtons()}
            </div>
        );
    }

    renderHeader(): JSX.Element {
        return (
            <div className={style.header}>
                <div>Monat</div>
                <div>Verbrauch{this.einheit ? ` [${this.einheit}]` : null}</div>
                <div style={this.disableKosten ? { display: 'none' } : {}}>
                    {`Kosten (${this.isVorsteuerNetto ? 'netto' : 'brutto'}) [€]`}
                </div>
                <div>CO₂-Emissionen [gCO₂/kWh]</div>
                <div>Bemerkung</div>
                <div>Rechnung</div>
                <div style={{ padding: '2px 0' }}>
                    {this.renderHilfeSymbol()}
                </div>
            </div>
        );
    }

    renderHilfeSymbol(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                // styleDivProps={{ display: 'inline-block', marginLeft: -100 }}
                styleDivProps={{ marginTop: 2, marginLeft: -62 }}
                // styleProps={{
                //     width: 18, height: 20, borderRadius: 10, backgroundColor: 'transparent', verticalAlign: 'top', margin: 0
                // }}
                styleProps={{ margin: 0 }}
                label='Rechner - Wärme'
                helpKey='dialog_rechner_waerme'
                style={'theme_small'}
                type={'theme_info'}
                customElement={'Info'}
                editBar
                useTheme
            />
        );
    }

    renderRow(index: number, isValid: boolean): JSX.Element {
        const values: any = this.state.data[index] || {};
        this.FormData.setAllValues({
            abrechnungsart: this.abrechnungsart,
            bemerkung: values.bemerkung,
            co2_emissionen: (values.co2_emissionen || null) && values.co2_emissionen.toString().length
                ? +values.co2_emissionen
                : (this.emissionsfaktor || '').toString(),
            einheit_tid: this.einheit_tid,
            energietraeger_tid: this.energietraeger_tid,
            kosten: this.getValue(values.kosten),
            verbrauch: this.getValue(values.verbrauch),
            isValid
        });

        return (
            <div className={style.fields}>
                <div>
                    {`${index}/${this.props.jahr}`}
                </div>
                <div>
                    <input
                        name='verbrauch'
                        type='number'
                        value={values.verbrauch || (values.verbrauch === 0 ? 0 : null)}
                        required
                        onChange={(evt: any) => {
                            this.onChange({ index, name: evt.target.name, value: evt.target.value });
                        }}
                    />
                    {this.renderValidation('verbrauch')}
                </div>
                <div style={this.disableKosten ? { display: 'none' } : {}}>
                    <input
                        name='kosten'
                        type='number'
                        value={values.kosten || (values.kosten === 0 ? 0 : null)}
                        required
                        onChange={(evt: any) => {
                            this.onChange({ index, name: evt.target.name, value: evt.target.value });
                        }}
                    />
                    {this.renderValidation('kosten')}
                </div>
                <div>
                    <input
                        name='co2_emissionen'
                        type='number'
                        placeholder={(this.emissionsfaktor || '').toString()}
                        value={values.co2_emissionen || (values.co2_emissionen === 0 ? 0 : null)}
                        disabled={this.autoCo2Emissionen}
                        required={!this.autoCo2Emissionen && !this.emissionsfaktor}
                        onChange={(evt: any) => {
                            this.onChange({ index, name: evt.target.name, value: evt.target.value });
                        }}
                    />
                    {this.renderValidation('co2_emissionen')}
                </div>
                <div>
                    <input
                        name='bemerkung'
                        type='text'
                        value={values.bemerkung}
                        onChange={(evt: any) => {
                            this.onChange({ index, name: evt.target.name, value: evt.target.value });
                        }}
                    />
                </div>
                <div>
                    <WFormFieldArchiv
                        entity={IDs.ENT_ENERGIEDATEN_WAERME}
                        label={null}
                        name='rechnung'
                        value={values.rechnung || 0}
                        data={values}
                        onValueChange={(name: string, value: any) => {
                            this.onChange({ index, name, value });
                        }}
                        module={IDs.MOD_ETOOL}
                        layout='noneAutoSave'
                    />
                </div>
            </div>
        );
    }

    // renderTitle(): JSX.Element {
    //     return (
    //         <div className={style.title}>
    //             <div>{this.props.jahr}</div>
    //             <div>{this.props.standortSelected.name}</div>
    //             <div>{this.energietraeger}</div>
    //             <div style={{ flex: 1, textAlign: 'right' }}>
    //                 <WHelpIcon
    //                     data={this.props.data}
    //                     styleDivProps={{ display: 'inline-block' }}
    //                     styleProps={{
    //                         width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0
    //                     }}
    //                     label='Rechner - Wärme'
    //                     helpKey='dialog_rechner_warme'
    //                     type='info'
    //                     editBar
    //                 />
    //             </div>
    //         </div>
    //     );
    // }

    renderValidation(key: string): JSX.Element {
        const { text, type } = this.validateField(key);

        if (!text) {
            return null;
        }

        return (
            <div
                className={formStyle.warnSignDlgRechner}
                style={{ ...(type === 'warning' && { color: '#616468' }) }}
                title={text}
            >
                *
            </div>
        );
    }

    renderVerbraeuche(): JSX.Element[] {
        const rows: JSX.Element[] = [];
        const values: any = this.state.data || {};
        let sumKehrwerte = 0;
        this.harmCo2Emissionen = 0;
        this.sumKosten = null;
        this.sumVerbrauch = 0;

        for (let i = 1; i <= 12; ++i) {
            const value: any = values[i] || {};
            const co2_emissionen: number = (
                typeof value.co2_emissionen === 'undefined' || value.co2_emissionen === null || value.co2_emissionen === ''
            )
                ? this.emissionsfaktor
                : +value.co2_emissionen;
            const kosten: number = Math.round((+value.kosten || 0) * 100) / 100;
            const verbrauch: number = +value.verbrauch || 0;
            const isValid: boolean = isValidWaerme(
                {
                    abrechnungsart: this.abrechnungsart, co2_emissionen: value.co2_emissionen, einheit_tid: this.einheit,
                    energietraeger_tid: this.energietraeger, kosten: typeof value.kosten !== 'undefined' ? value.kosten : null,
                    verbrauch: value.verbrauch, bemerkung: value.bemerkung
                },
                IDs.ENT_ENERGIEDATEN_WAERME,
                this.props.data
            );
            this.sumVerbrauch += isValid ? verbrauch : 0;
            this.sumKosten = isValid
                ? (value.kosten !== null ? Math.round((+this.sumKosten + kosten) * 100) / 100 : this.sumKosten)
                : this.sumKosten;
            sumKehrwerte += isValid ? verbrauch * co2_emissionen : 0;
            rows.push(
                <React.Fragment key={`row-${i}`}>{this.renderRow(i, isValid)}</React.Fragment>
            );
        }
        this.harmCo2Emissionen = this.sumVerbrauch ? (sumKehrwerte / this.sumVerbrauch) : 0;

        return rows;
    }

    saveData(): void {
        const datum = new Date().getTime() / 1000;
        const row: any = this.props.values || {};
        const saveList: any[] = [];
        const waerme: any[] = this.props.data[IDs.ENT_ENERGIEDATEN_WAERME] || [];
        const values: any = this.state.data || {};
        const parent_tid = row.tid || 0;
        const energietraeger_tid = typeof row.energietraeger_tid === 'number'
            ? row.energietraeger_tid
            : (typeof row.energietraeger_tid_orig === 'number' ? row.energietraeger_tid_orig : 0);
        const einheit_tid = typeof row.energietraeger_tid === 'number'
            ? row.einheit_tid
            : (typeof row.einheit_tid_orig === 'number' ? row.einheit_tid_orig : 0);
        const data = waerme
            ? waerme.filter((item: any) =>
                item.standort_tid_orig === this.props.standortSelected.tid
                && item.jahr === this.props.jahr
                && +item.monat >= 1
                && (item.energietraeger_tid_orig || 0) === energietraeger_tid
                && (item.einheit_tid_orig || 0) === einheit_tid
                && item.parent_tid === parent_tid
            ) : [];
        let countValid: number = 0;
        let harmCo2Emissionen = 0;
        let sumKehrwerte = 0;
        let sumKosten: number = null;
        let sumVerbrauch = 0;

        for (let i = 1; i <= 12; ++i) {
            const value: any = values[i] || {};
            const abrechnungszeitraum_bis = Moment([this.props.jahr, i - 1]).endOf('month').unix();
            const abrechnungszeitraum_von = Moment([this.props.jahr, i - 1]).startOf('month').unix();
            const bemerkung: string = value.bemerkung;
            const co2_emissionen = (
                typeof value.co2_emissionen === 'undefined' || value.co2_emissionen === null || value.co2_emissionen === ''
            )
                ? null
                : !this.autoCo2Emissionen ? +value.co2_emissionen : null;
            const kosten = this.getValue(value.kosten) !== null ? Math.round(value.kosten * 100) / 100 : null;
            const rechnung = +value.rechnung || 0;
            const rechnung_archiv_delete = value.rechnung_archiv_delete || 0;
            const rechnung_archiv_filename = value.rechnung_archiv_filename || null;
            const rechnung_archiv_rawdata = value.rechnung_archiv_rawdata || null;
            const verbrauch = +value.verbrauch || 0;
            const isValid: boolean = isValidWaerme(
                {
                    abrechnungsart: this.abrechnungsart, co2_emissionen: value.co2_emissionen, einheit_tid: this.einheit,
                    energietraeger_tid: this.energietraeger, kosten: typeof value.kosten !== 'undefined' ? value.kosten : null,
                    verbrauch: value.verbrauch, bemerkung: value.bemerkung
                },
                IDs.ENT_ENERGIEDATEN_WAERME,
                this.props.data
            );
            const tid: number = value.tid || null;
            const found = data.find((item: any) => item.tid === (value.tid || null));
            countValid += +isValid;
            sumVerbrauch += isValid ? verbrauch : 0;
            sumKosten = isValid
                ? (kosten !== null ? Math.round((+sumKosten + kosten) * 100) / 100 : sumKosten)
                : sumKosten;
            sumKehrwerte += isValid
                ? verbrauch * (co2_emissionen === null ? this.emissionsfaktor : +co2_emissionen)
                : 0;

            if (found) { // Wenn Datensatz schon vorhanden --> immer speichern
                saveList.push({
                    tid,
                    parent_tid,
                    verbrauch: this.getValue(value.verbrauch),
                    kosten,
                    co2_emissionen,
                    rechnung,
                    ...(rechnung_archiv_delete ? { rechnung_archiv_delete } : {}),
                    ...(rechnung_archiv_filename ? { rechnung_archiv_filename } : {}),
                    ...(rechnung_archiv_rawdata ? { rechnung_archiv_rawdata } : {}),
                    bemerkung,
                    datum,
                    abrechnungszeitraum_von: found.abrechnungszeitraum_von,
                    abrechnungszeitraum_bis: found.abrechnungszeitraum_bis
                });
            } else if (
                verbrauch > 0 || kosten > 0 || (!this.autoCo2Emissionen && co2_emissionen !== null) || rechnung > 0
                || rechnung_archiv_rawdata
            ) {
                const newItem = {
                    parent_tid,
                    ...(this.getValue(value.verbrauch) !== null ? { verbrauch } : {}),
                    ...(kosten !== null ? { kosten } : {}),
                    ...(co2_emissionen !== null ? { co2_emissionen } : {}),
                    rechnung,
                    ...(rechnung_archiv_delete ? { rechnung_archiv_delete } : {}),
                    ...(rechnung_archiv_filename ? { rechnung_archiv_filename } : {}),
                    ...(rechnung_archiv_rawdata ? { rechnung_archiv_rawdata } : {}),
                    bemerkung,
                    datum,
                    abrechnungszeitraum_von,
                    abrechnungszeitraum_bis,
                    energietraeger_tid,
                    einheit_tid,
                    jahr: this.props.jahr,
                    monat: i,
                    standort_tid: this.props.standortSelected.tid
                };
                saveList.push(newItem);
            }
        }
        harmCo2Emissionen = +(sumVerbrauch ? (sumKehrwerte / sumVerbrauch) : 0).toFixed(2);

        if (
            this.props.jahr !== Moment().year() && countValid !== 12
            && !window.confirm(`Die Monatsdatensätze (${12 - countValid}/12) wurden nicht vollständig eingegeben, trotzdem speichern?`)
        ) {
            return;
        }

        if (saveList.length > 0) {
            const pAzVon = this.getParentAbrechnungszeitraumVon(saveList);
            const pAzBis = this.getParentAbrechnungszeitraumBis(saveList);
            // Speichere Monatsdaten durch dataService.saveDataList
            this.setState({ showSpinner: true }, () => {
                window.setTimeout(() => this.props.onClose(), 100); // FIXME - das ist ein Hack, den ich auf die Schnelle einbauen musste
                // Aus Word-Datei vom 7.6.2025 (Punkt 1)
                this.dataService.saveDataList(IDs.ENT_ENERGIEDATEN_WAERME, saveList, (sql: string, success: boolean) => {
                    this.setState({ showSpinner: false });
                    // Speichere Jahresdaten durch onChange
                    const valueYearFound = waerme.find((item: any) => item.tid === row.tid);
                    let valueYear;
                    if (valueYearFound) { // Wenn Datensatz schon vorhanden --> immer speichern
                        valueYear = {
                            tid: valueYearFound.tid,
                            _formKey: row._formKey,
                            verbrauch: sumVerbrauch,
                            kosten: sumKosten,
                            co2_emissionen: !this.autoCo2Emissionen ? harmCo2Emissionen : null,
                            datum: row.datum,
                            abrechnungszeitraum_von: pAzVon,
                            abrechnungszeitraum_bis: pAzBis,
                            // energietraeger_tid,
                            einheit_tid,
                            jahr: this.props.jahr,
                            standort_tid: this.props.standortSelected.tid
                        };
                        this.props.onChange(IDs.ENT_ENERGIEDATEN_WAERME, valueYear);
                    } else if (sumVerbrauch > 0 || sumKosten > 0 || harmCo2Emissionen > 0) {
                        valueYear = {
                            _formKey: row._formKey,
                            verbrauch: sumVerbrauch,
                            ...(sumKosten !== null ? { kosten: sumKosten } : {}),
                            co2_emissionen: !this.autoCo2Emissionen ? harmCo2Emissionen : null,
                            datum: row.datum,
                            abrechnungszeitraum_von: pAzVon,
                            abrechnungszeitraum_bis: pAzBis,
                            einheit_tid,
                            jahr: this.props.jahr,
                            standort_tid: this.props.standortSelected.tid
                        };
                        this.props.onChange(IDs.ENT_ENERGIEDATEN_WAERME, valueYear);
                    }
                    this.props.onClose();
                }, IDs.MOD_ETOOL);
            });
        } else {
            this.props.onClose();
        }
    }

    validateField(key: string): { text: string, type: string } {
        const requiredFields = ['kosten', 'verbrauch'];
        const co2_required = !this.autoCo2Emissionen && !this.emissionsfaktor;
        if (co2_required) {
            requiredFields.push('co2_emissionen');
        }

        const hasData: boolean = requiredFields.reduce((hasData: boolean, key: string) => !hasData ? this.FormData.getValue(key) !== null : true, false);
        const name: string = (key || '').length ? key === 'co2_emissionen' ? 'CO₂-Emissionen'
            : (key || '').replace(/^\w/, (name: string) => name.toUpperCase())
            : null;
        const value = this.FormData.getValue(key);
        let text: string = null;
        let type: string = null;

        if (
            (value === null || value === '') && key !== 'kosten'
            && (this.props.jahr !== Moment().year() || (this.props.jahr === Moment().year() && hasData))
        ) {
            text = `Bitte Feld "${name}" ausfüllen`;
            type = 'error';
        } else {
            if(!this.FormData.getValue('isValid')) {
                text = removeErrorLevelAddOn(
                    validateFieldUniversal(
                        IDs.ENT_ENERGIEDATEN_WAERME, key, value, this.FormData, null, this.props.data,
                        (data: any) => type = (data || {}).type || null
                    )
                );
            }
        }

        return { text, type };
    }
}
